import PropTypes from "prop-types";
import { BbotRichTextInput, Button, SettingsCard } from "top-component-library";
import { QUILL_FORMATS, QUILL_MODULES } from "../constants";
import { EditorLabel, QuillWrapper, SaveRow } from "../styles";

const StoreHoursCard = ({ storeHours, onChange, onSave }) => (
  <SettingsCard title="Displayed Store Hours">
    <div>
      <p>
        Store hours shown on your website. This is for display purposes only; it has no control over when your menus or
        stations are actually enabled.
      </p>
      <p>Here is one example you can copy, paste into the box below, and edit:</p>
      <div>
        <h4>Pickup:</h4>
        <p>
          <strong>Mon-Fri:</strong> 9AM - 10PM
        </p>
        <p>
          <strong>Sat:</strong> 12PM - 3AM
        </p>
        <p>
          <strong>Sun:</strong> CLOSED
        </p>
        <h4>Delivery:</h4>
        <p>
          <strong>Mon-Fri:</strong> 12PM - 6PM
        </p>
        <p>
          <strong>Sat:</strong> Unavailable
        </p>
        <p>
          <strong>Sun:</strong> Unavailable
        </p>
      </div>
      <EditorLabel>Store Hours Text</EditorLabel>
      <QuillWrapper>
        <BbotRichTextInput
          value={storeHours}
          onChange={(html) => onChange(html)}
          modules={QUILL_MODULES}
          formats={QUILL_FORMATS}
        />
      </QuillWrapper>
      <SaveRow>
        <Button type="primary" onClick={onSave}>
          Save
        </Button>
      </SaveRow>
    </div>
  </SettingsCard>
);

StoreHoursCard.propTypes = {
  storeHours: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default StoreHoursCard;
